import React from "react";
import { useTranslation } from "react-i18next";
import {
  HiOutlineSearch,
  HiOutlineSparkles,
  HiOutlineCheckCircle,
} from "react-icons/hi";

const AiSearchHowItWorks: React.FC = () => {
  const { t } = useTranslation();

  const benefits = [
    t("dashboard.aiConfig.searchHow.benefit1"),
    t("dashboard.aiConfig.searchHow.benefit2"),
    t("dashboard.aiConfig.searchHow.benefit3"),
  ];

  return (
    <div className="bg-white border border-gray-200 rounded-xl p-4 sm:p-6 lg:p-8 mb-6">
      <div className="text-center max-w-2xl mx-auto">
        <div className="inline-flex items-center justify-center w-12 h-12 sm:w-14 sm:h-14 rounded-xl bg-blue-50 text-blue-600 mb-3 sm:mb-4">
          <HiOutlineSearch className="w-6 h-6 sm:w-7 sm:h-7" />
        </div>
        <h2 className="text-lg sm:text-xl lg:text-2xl font-bold text-gray-900 leading-tight">
          {t("dashboard.aiConfig.searchHow.title")}
        </h2>
        <p className="text-xs sm:text-sm text-gray-600 mt-2">
          {t("dashboard.aiConfig.searchHow.subtitle")}
        </p>
      </div>

      <div className="mt-6 sm:mt-8 max-w-2xl mx-auto bg-gray-50 border border-gray-200 rounded-xl p-4 sm:p-5">
        <div className="flex justify-end mb-3">
          <div className="inline-flex items-start gap-2 bg-blue-600 text-white rounded-xl rounded-br-sm px-3 py-2 max-w-[85%]">
            <HiOutlineSearch
              size={16}
              className="mt-0.5 flex-shrink-0 opacity-80"
            />
            <span className="text-sm leading-snug">
              {t("dashboard.aiConfig.searchHow.demoQuestion")}
            </span>
          </div>
        </div>
        <div className="flex justify-start">
          <div className="inline-flex items-start gap-2 bg-white border border-gray-200 text-gray-800 rounded-xl rounded-bl-sm px-3 py-2 max-w-[85%] shadow-sm">
            <span className="inline-flex items-center justify-center w-5 h-5 rounded-full bg-blue-100 text-blue-600 flex-shrink-0 mt-0.5">
              <HiOutlineSparkles size={12} />
            </span>
            <span className="text-sm leading-snug">
              {t("dashboard.aiConfig.searchHow.demoAnswer")}
            </span>
          </div>
        </div>
      </div>

      <div className="mt-5 flex flex-col sm:flex-row flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs text-gray-600">
        {benefits.map((b, i) => (
          <span key={i} className="inline-flex items-center gap-1.5">
            <HiOutlineCheckCircle
              size={16}
              className="text-green-600 flex-shrink-0"
            />
            <span className="text-center">{b}</span>
          </span>
        ))}
      </div>
    </div>
  );
};

export default AiSearchHowItWorks;
